'use client'

import * as React from 'react'
import { cn } from "@shared/utils"
import { useFormField } from '../../hooks/useFormField'

/**
 * @group Components
 * 
 * @summary
 * <blockquote>Description text for a form item, linked via aria-describedby.</blockquote>
 * 
 * @example
 * ```typescript
 * import { FormDescription } from '@shared/ui'
 * 
 * <FormDescription>
 *   We'll never share your email with anyone else.
 * </FormDescription>
 * ```
 */
export const FormDescription = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => {
  const { formDescriptionId } = useFormField()

  return (
    <p
      ref={ref}
      id={formDescriptionId}
      className={cn('text-[0.8rem] text-muted-foreground', className)}
      {...props}
    />
  )
})
FormDescription.displayName = 'FormDescription' 